/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Notifications_Alldeals2Inputs */

const en_coinvestments_notifications_alldeals2 = /** @type {(inputs: Coinvestments_Notifications_Alldeals2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All deals`)
};

/**
* | output |
* | --- |
* | "All deals" |
*
* @param {Coinvestments_Notifications_Alldeals2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_notifications_alldeals2 = /** @type {((inputs?: Coinvestments_Notifications_Alldeals2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Notifications_Alldeals2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_notifications_alldeals2(inputs)
});
export { coinvestments_notifications_alldeals2 as "coInvestments_notifications_allDeals" }